import Sidebar from './Sidebar';
import { useLocation } from 'react-router-dom';

const SuperAdminSidebar = () => {
  const location = useLocation();
  const { companyId, companyName } = location.state || {};
  
  return <Sidebar 
    role="superadmin" 
    additionalData={{ companyId, companyName }} 
  />;
};

export default SuperAdminSidebar;
